class ClusterCustomer {
    constructor(
        id,
        type,
        age,
        birthday,
        email,
        firstName,
        lastName,
        displayName,
        dni,
        cuil,
        gender,
        locality,
        phoneType,
        phoneNumber,
        flat,
        floor,
        streetName,
        streetNumber,
        businessName,
        contacts
    ) {
        this.id = id
        this.type = type
        this.age = age
        this.birthday = birthday
        this.email = email
        this.firstName = firstName
        this.lastName = lastName
        this.displayName = displayName
        this.fullName = `${this.firstName} ${this.lastName}`
        this.dni = dni
        this.cuil = cuil
        this.gender = gender
        this.locality = locality
        this.phoneType = phoneType
        this.phoneNumber = phoneNumber
        this.flat = flat
        this.floor = floor
        this.streetName = streetName
        this.streetNumber = streetNumber
        this.businessName = businessName
        this.contacts = contacts
    }

    static fromJson({
        id,
        type,
        age,
        birthday,
        email,
        name,
        lastName,
        displayName,
        identityNumber,
        singleTaxIdentification,
        gender,
        locality,
        phoneType,
        phoneNumber,
        flat,
        floor,
        streetName,
        streetNumber,
        businessName,
        contacts,
    }) {
        return new ClusterCustomer(
            id,
            type,
            age,
            birthday,
            email,
            name,
            lastName,
            displayName,
            identityNumber,
            singleTaxIdentification,
            gender,
            locality,
            phoneType,
            phoneNumber,
            flat,
            floor,
            streetName,
            streetNumber,
            businessName,
            contacts
        )
    }

    fromStorage({ name, lastName }) {
        this.name = name
        this.lastName = lastName
    }

    get displayLabel() {
        return this.displayName || this.businessName || this.fullName
    }
}

export default ClusterCustomer
